export default __webpack_public_path__ + "static/and-case-4-433dbb723f1b7f7146624b730a400fb2.webp";